import styled from 'styled-components';

import { BACKGROUND_HEADER, BACKGROUND_HEADER_LOGO, BORDER_HEADER, BORDER_HEADER_LOGO, BORDER_HEADER_LOGO_RIGHT, BORDER_HEADER_LEFT, WIDTH_SIDE_BAR, FONT_SIZE_HEADER_LOGO, BACKGROUND_HEADER_MOBILE } from '../../../globals';


export const StyledHeader = styled.div`
  top: 0;  
  left: 0;
  position: fixed;
  width: 100%;
  overflow: hidden;
  z-index: 500;
  margin: 0px;
  padding: 0px;
  
  .header-row {
    display: table;
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    position: relative;
  }

  .header-column {
    display: table-cell;
  }

  .header-logo {
    height: 50px;
    width: ${WIDTH_SIDE_BAR}px;
    background-color: ${BACKGROUND_HEADER_LOGO}; 
    border-bottom: 2px solid ${BORDER_HEADER_LOGO}; 
    border-right: 1px solid ${BORDER_HEADER_LOGO_RIGHT}; 
    z-index: 500;

    text-align: center;
    vertical-align: middle;
    color: white;
    font-size: ${FONT_SIZE_HEADER_LOGO}em;
  }

  .header-logo-img {
    max-height: 35px;
  }

  .header-panel {
    background-color: ${BACKGROUND_HEADER}; 
    border-bottom: 2px solid ${BORDER_HEADER}; 
    border-left: 1px solid ${BORDER_HEADER_LEFT}; 
    border: colapse;
    z-index: 500;
    vertical-align: middle;
    text-align: center;
  }

  .header-panel--title-small {
    display: none;
  }

  .header-panel--title {
    color: white;
    font-size: 1.75rem;
    font-weight: bold;
    padding-left: 7px;
    padding-right: 7px;
  }

  .header-panel--item {
    position: absolute;
    top: 7px;
    right: 0;
    color: white;
    font-weight: bold;
    padding: 7px;
    cursor: pointer;
  }

  .header-panel--item:hover {
    color: ${BACKGROUND_HEADER};
    background: white;
  }

  .header-text {
    margin: 5px;
    color: inherit;
    text-decoration: none;
   }

  .btn-office-content:hover, .btn-office-content:visited, .btn-office-content:active {
    text-decoration: none;
  }


  @media (max-width: 767px) {
    position: relative;
    

    .header-logo {
      background-color: ${BACKGROUND_HEADER_MOBILE}; 
      width: 100%; 
      border-bottom: 2px solid ${BORDER_HEADER_LOGO}; 
      border-right: none; 
      text-align: left;
    }

    .header-panel--title-small {
      background-color: ${BACKGROUND_HEADER_LOGO}; 
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      width: 100%;
      line-height: 50px;
    }

    .header-panel--title-wide {
      display: none;
    }

    .header-panel {
      width: 0px;
      background-color: transaprent; 
      border-bottom: none; 
      border-left: none; 
    }

    .header-panel--item {
      font-size: 1.25em;
      top: 5px;
    }

    .header-panel--item-text {
      display: none;
    }
  }

`;



// WEBPACK FOOTER //
// ./src/components/Header/styles/StyledHeader.js